module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid account-screen section"
  }, [_c('account-information', {
    attrs: {
      "carriers": _vm.carriers,
      "details": _vm.accountDetails,
      "mrc": _vm.calculateTotalMrc
    },
    on: {
      "accountUpdate": _vm.accountUpdate
    }
  }), _vm._v(" "), (_vm.accountDetails.carrier_id) ? _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab == 'cashflow'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'cashflow'
      }
    }
  }, [_vm._v("Cashflow")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab == 'details'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'details'
      }
    }
  }, [_vm._v("Details")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.accountDetails.carrier_id) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'details'),
      expression: "activeTab == 'details'"
    }],
    staticClass: "col-holder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [(_vm.accountDetails.account_id) ? _c('account-products', {
    attrs: {
      "carriers": _vm.carriers,
      "details": _vm.accountDetails,
      "carrierProducts": _vm.carrierProducts
    }
  }) : _vm._e(), _vm._v(" "), _c('account-contacts', {
    attrs: {
      "details": _vm.accountDetails,
      "accountContacts": _vm.accountContacts
    },
    on: {
      "accountContactsUpdate": _vm.accountContactsUpdate,
      "accountContactsDelete": _vm.accountContactsDelete
    }
  }), _vm._v(" "), _c('account-statement-matches', {
    attrs: {
      "details": _vm.accountDetails,
      "accountStatementMatches": _vm.accountStatementMatches
    },
    on: {
      "accountStatementMatchDelete": _vm.deleteAccountStatementMatch
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('account-notes', {
    attrs: {
      "account_id": _vm.$route.params.account_id,
      "details": _vm.accountDetails
    }
  }), _vm._v(" "), _c('account-agents', {
    attrs: {
      "account_id": _vm.$route.params.account_id,
      "carrier_id": _vm.accountDetails.carrier_id
    }
  }), _vm._v(" "), _c('account-files', {
    attrs: {
      "details": _vm.accountDetails
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('cashflow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'cashflow'),
      expression: "activeTab == 'cashflow'"
    }],
    attrs: {
      "source_id": _vm.params.data.account_id,
      "sourceFn": "accountCashflow",
      "label": "Account",
      "name": _vm.accountDetails.name
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a93efa5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/AccountDetails.vue
// module id = 415
// module chunks = 0